import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
  IconButton,
  Container,
} from "@mui/material";
import { Fade } from "react-awesome-reveal";
import { Link, useNavigate } from "react-router-dom";
import {
  baseUrl,
  useApplyLinksMutation,
  useFindMyJobApiQuery,
  useFindUserApiQuery,
} from "../../../services/apiSlice";
import dayjs from "dayjs";
import { MyJobModal, TransitionsModal } from "../../modal/viewJob";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/system";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { green, red } from "@mui/material/colors";
import DeleteModal from "../CustomerOrBussiness/Delete";
import { useState } from "react";
import { ApplyForJob } from "../../Apply";

export const GetJobSearchResult = ({ AllResult }) => {
  console.log({ AllResult });

  const [applyLinks, { data: dat, error, isError }] = useApplyLinksMutation();
  const {
    data,
    error: e,
    isError: is,
    isSuccess: suc,
    isFetching,
  } = useFindUserApiQuery();
  const [isApply, setIsApply] = useState(false);
  const navigate = useNavigate();

  if (isApply === true) {
    Swal.fire(
      "Update Profile!",
      `  You need to update your profile before you can apply or send quote to customer's. Thanks!!`,
      "info"
    ).then((result) => {
      if (result.isConfirmed || result.isDismissed) {
        navigate(`/dashboard/create-profile`);
      }
    });
  }

  return (
    <>
      <Fade cascade>
        <Grid
          container
          item
          spacing={{ xs: 2, md: 4, my: 10 }}
          columns={{ xs: 12, sm: 8, md: 12 }}
        >
          {AllResult?.length === 1
            ? AllResult?.map((v, i) => (
                <>
                  <Grid
                    key={v._id}
                    // className="w-full"
                    sx={[
                      { px: 3, mx: 5, width: "100%" },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ maxWidth: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}{" "}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button
                          sx={[
                            {
                              color: "white",
                              px: 4,
                              py: 3,
                              background: green[600],
                            },
                            (theme) => ({
                              [theme.breakpoints.down("sm")]: {
                                py: 2,

                                px: 2,
                              },
                            }),
                          ]}
                          size="small"
                        >
                          {!isFetching &&
                          data?.getUserObject?.hasProfile === false ? (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() => setIsApply(true)}
                            >
                              Apply{" "}
                            </Button>
                          ) : (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() =>
                                ApplyForJob({
                                  jobId: v._id,
                                  applyLinks,
                                  isError,
                                  error,
                                })
                              }
                            >
                              Apply
                            </Button>
                          )}
                        </Button>
                        <TransitionsModal singleJob={v} />
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))
            : AllResult.length === 2
            ? AllResult?.map((v, i) => (
                <>
                  <Grid
                    key={v._id}
                    className="lg:w-[50%]  md:pb-5 md:w-[50%]  sm:w-2/4"
                    sx={[
                      { px: 3, my: 6 },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ maxWidth: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button
                          sx={[
                            {
                              color: "white",
                              px: 4,
                              py: 3,
                              mx: 3,
                              background: green[600],
                            },
                            (theme) => ({
                              [theme.breakpoints.down("sm")]: {
                                py: 2,

                                px: 2,
                              },
                            }),
                          ]}
                          size="small"
                        >
                          {!isFetching &&
                          data?.getUserObject?.hasProfile === false ? (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() => setIsApply(true)}
                            >
                              Apply{" "}
                            </Button>
                          ) : (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() =>
                                ApplyForJob({
                                  jobId: v._id,
                                  applyLinks,
                                  isError,
                                  error,
                                })
                              }
                            >
                              Apply
                            </Button>
                          )}
                        </Button>
                        <TransitionsModal singleJob={v} />
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))
            : AllResult?.map((v, i) => (
                <>
                  <Grid
                    key={v._id}
                    className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
                    sx={[
                      { px: 2, my: 6 },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ width: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              textTransform: "capitalize",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button
                          sx={[
                            {
                              color: "white",
                              px: 4,
                              py: 3,
                              mx: 3,
                              background: green[600],
                            },
                            (theme) => ({
                              [theme.breakpoints.down("sm")]: {
                                py: 2,

                                px: 2,
                              },
                            }),
                          ]}
                          size="small"
                        >
                          {!isFetching &&
                          data?.getUserObject?.hasProfile === false ? (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() => setIsApply(true)}
                            >
                              Apply{" "}
                            </Button>
                          ) : (
                            <Button
                              sx={{ color: "white" }}
                              onClick={() =>
                                ApplyForJob({
                                  jobId: v._id,
                                  applyLinks,
                                  isError,
                                  error,
                                })
                              }
                            >
                              Apply
                            </Button>
                          )}
                        </Button>
                        <TransitionsModal singleJob={v} />
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))}
        </Grid>

        {/* <Paper
          sx={[
            {
              maxWidth: "lg",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ml: 10,
              my: 15,
            },
            (theme) => ({
              [theme.breakpoints.down("sm")]: {
                py: 3,
                mx: 3,
                ml: 3,
              },
            }),
          ]}
        >
          <Typography
            variant="p"
            component="p"
            className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
          >
            Upgrade today to enjoy the full benefits of TOP Neigbourhood Pro's
            Premium Membership
          </Typography>
          <Link to={"/dashboard/premium-plan"}>
            <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
              Find out more
            </Button>
          </Link>
        </Paper> */}
      </Fade>
    </>
  );
};
export const GetMyJobResult = () => {
  const { data, error, isError, isSuccess, isFetching } =
    useFindMyJobApiQuery();
  console.log({ data });

  return (
    <>
      <Fade cascade>
        <Grid
          container
          item
          spacing={{ xs: 2, md: 4, my: 10 }}
          columns={{ xs: 12, sm: 8, md: 12 }}
        >
          {!isFetching && data?.getAvailableJob?.length === 1
            ? !isFetching &&
              data?.getAvailableJob?.map((v, i) => (
                <>
                  <Grid
                    key={i}
                    // className="w-full"
                    sx={[
                      { px: 3, mx: 5, width: "100%" },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ maxWidth: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}{" "}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Status:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.status}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Box
                          sx={[
                            {
                              display: "flex",
                              px: 2,
                              py: 4,
                            },
                            (theme) => ({
                              [theme.breakpoints.down("sm")]: {
                                // display: "none",
                              },
                            }),
                          ]}
                        >
                          <Tooltip title="Edit Job">
                            <Link to={`/dashboard/edit-job/${v._id}`}>
                              <IconButton
                                sx={[
                                  { px: 3 },
                                  (theme) => ({
                                    [theme.breakpoints.down("sm")]: {
                                      px: 1,
                                    },
                                  }),
                                ]}
                              >
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          <DeleteModal jobId={v._id} />
                          <MyJobModal singleJob={v} />
                        </Box>
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))
            : !isFetching && data?.getAvailableJob?.length === 2
            ? !isFetching &&
              data?.getAvailableJob?.map((v, i) => (
                <>
                  <Grid
                    key={i}
                    className="lg:w-[50%]  md:pb-5 md:w-[50%]  sm:w-2/4"
                    sx={[
                      { px: 3, my: 6 },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ maxWidth: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Status:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.status}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        {/* <Link to={"/check"}>learnmore</Link>
                          <Button size="small">Share</Button> */}
                        <Box
                          sx={{
                            display: "flex",
                            px: 2,
                            py: 4,
                          }}
                        >
                          <Tooltip title="Edit Job">
                            <Link to={`/dashboard/edit-job/${v._id}`}>
                              <IconButton
                                sx={[
                                  { px: 3 },
                                  (theme) => ({
                                    [theme.breakpoints.down("sm")]: {
                                      px: 1,
                                    },
                                  }),
                                ]}
                              >
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          <DeleteModal jobId={v._id} />
                          {/* <Button size="small"> </Button>{" "} */}
                          <MyJobModal singleJob={v} />
                        </Box>
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))
            : !isFetching &&
              data?.getAvailableJob?.map((v, i) => (
                <>
                  <Grid
                    key={i}
                    className="lg:w-[30%] md:pb-5 md:w-[40%]  sm:w-2/4"
                    sx={[
                      { px: 2, my: 6 },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          width: "90%",
                          py: 3,
                          mx: 3,
                        },
                      }),
                    ]}
                  >
                    <Card sx={{ width: "100%" }}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`${baseUrl + `upload/job/` + v?.files[0]?.path}`}
                        alt="green iguana"
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            color: "black",

                            textTransform: "capitalize",
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {v?.categories}
                        </Typography>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 16,
                            textTransform: "capitalize",
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          {v?.job_description}
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Date Posted:{" "}
                          <Typography
                            sx={{
                              color: "black",
                            }}
                            variant="span"
                          >
                            {dayjs(v?.dateCreated).format(
                              "dddd, MMMM D, YYYY h:mm A"
                            )}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          posted By:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              textTransform: "capitalize",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {v?.createdBy}
                          </Typography>
                        </Typography>{" "}
                        <Typography variant="body2" color="text.secondary">
                          Status:
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: 18,
                              px: 2,
                              textTransform: "capitalize",
                            }}
                            variant="span"
                          >
                            {v?.status}
                          </Typography>
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Box
                          sx={{
                            display: "flex",
                            px: 2,
                            py: 4,
                          }}
                        >
                          <Tooltip title="Edit Job">
                            <Link to={`/dashboard/edit-job/${v._id}`}>
                              <IconButton
                                sx={[
                                  { px: 3 },
                                  (theme) => ({
                                    [theme.breakpoints.down("sm")]: {
                                      px: 1,
                                    },
                                  }),
                                ]}
                              >
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          {/* <Button onClick={Delete} size="small">
                            <IconButton>
                              <DeleteIcon sx={{ color: red[600] }} />
                            </IconButton>
                          </Button>{" "} */}
                          <DeleteModal jobId={v._id} />
                          <MyJobModal singleJob={v} />
                          {/* <Button size="small"> </Button>{" "} */}
                          {/* <MyJobModal singleJob={v} /> */}
                        </Box>
                      </CardActions>
                    </Card>{" "}
                    {/* <Item>3</Item> */}
                  </Grid>
                </>
              ))}
        </Grid>

        {/* <Paper
          sx={[
            {
              maxWidth: "lg",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ml: 10,
              my: 15,
            },
            (theme) => ({
              [theme.breakpoints.down("sm")]: {
                py: 3,
                mx: 3,
                ml: 3,
              },
            }),
          ]}
        >
          <Typography
            variant="p"
            component="p"
            className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
          >
            Upgrade today to enjoy the full benefits of TOP Neigbourhood Pro's
            Premium Membership
          </Typography>
          <Link to={"/dashboard/premium-plan"}>
            <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
              Find out more
            </Button>
          </Link>
        </Paper> */}
      </Fade>
    </>
  );
};
